module.exports = __webpack_public_path__ + "static/kartchen_hotels-fe25971caa76028db9413148ac257241.png";